import React, { useEffect, useRef, useState } from "react";

const Select = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [result, setResult] = useState("");
  const [selected, setSelected] = useState([]);
  const inputRef = useRef(null);

  const clearOption = () => {
    onChange(undefined);
    setSearch("");
    setSelected([]);
  };

  const selectOption = (option) => {
    if (option !== value) onChange(option);
  };

  function isOptionSelected(option) {
    return option === value;
  }

  useEffect(() => {
    setHighlightedIndex(0);
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const searchResult = (tag) => {
    const regx = new RegExp(tag, "i");
    return options.filter((obj) => regx.test(obj.label));
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setResult(searchResult(e.target.value));
  };

  const handleToggleOption = (option) => {
    const isSelected = selected.some(
      (selected) => selected.value === option.value
    );

    if (isSelected) {
      setSelected(
        selected.filter((selected) => selected.value !== option.value)
      );
    } else {
      setSelected([...selected, option]);
    }
  };

  const selectAll = () => {};
  return (
    <div
      className="border border-gray-400 relative w-80 min-h-10 flex items-center gap-2 p-2 rounded outline-none cursor-text focus:border-blue-400"
      onClick={() => setIsOpen((prev) => !prev)}
      tabIndex={0}
    >
      <div className="flex flex-wrap  items-center  gap-2 w-full">
        {selected &&
          selected.map((item) => {
            return (
              <button
                key={item}
                className="flex items-center border bg-gray-200 border-gray-500 rounded-2xl px-1 gap-1 cursor-pointer justify-center outline-none hover:bg-red-200 hover:border-red-400 hover:text-red-500"
              >
                {item?.label}{" "}
                <span className="bg-transparent border-none outline-none cursor-pointer p-0 text-lg text-red-500">
                  &times;
                </span>
              </button>
            );
          })}
        <input
          type="text"
          ref={inputRef}
          className=" outline-none min-w-5 text-base"
          onChange={(e) => handleSearchChange(e)}
          value={search}
        />
      </div>
      <button
        className="bg-transparent text-gray-500 border-none outline-none cursor-pointer p-0 text-xl focus:text-gray-700 hover:text-gray-700"
        onClick={(e) => {
          e.stopPropagation();
          clearOption();
        }}
      >
        &times;
      </button>
      <div className="bg-gray-500 self-stretch w-[0.05em]"></div>
      <div
        className="bg-transparent text-gray-500 border-none outline-none cursor-pointer p-0 text-base focus:text-gray-700 hover:text-gray-700"
        onClick={selectAll}
      >
        &#10003;
      </div>
      <ul
        className={`absolute m-0 p-0 list-none max-h-60 overflow-y-auto border border-gray-400 rounded w-full left-0 top-full mt-1 bg-white z-50 ${
          isOpen ? "" : "hidden"
        }`}
      >
        {result
          ? result?.map((option, index) => (
              <li
                key={option.value}
                className={`cursor-pointer p-2  ${
                  isOptionSelected(option) ? "bg-blue-400 text-white" : ""
                } ${
                  highlightedIndex === index ? "bg-blue-500 text-white" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  selectOption(option);
                  setIsOpen(false);
                }}
                onMouseEnter={() => setHighlightedIndex(index)}
              >
                {option.label}
              </li>
            ))
          : options?.map((option, index) => (
              <li
                key={option.value}
                className={`cursor-pointer p-2  ${
                  isOptionSelected(option) ? "bg-blue-400 text-white" : ""
                } ${
                  highlightedIndex === index ? "bg-blue-500 text-white" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  selectOption(option);
                  setSelected((prev) => [...prev, option]);
                  setIsOpen(false);
                  handleToggleOption(option);
                }}
                onMouseEnter={() => setHighlightedIndex(index)}
              >
                {option.label}
              </li>
            ))}
      </ul>
      {/* {console.log(selected)} */}
    </div>
  );
};

export default Select;
